<template>
  <div class="h-dialogContainer h-nomargin">
    <div class="height-420 row m-b-10">
      <div class="col-sm-3 nopadding:last-child">
        <div class="h-borderBox height-400">
          <div class="h-borderBox-top">
            <ejs-textbox
              :placeholder='$t("Software.enterKeywordSearchDevice")'
              @keydown.enter.native="searchMethod"
              v-model="input"
            />
          </div>
          <ejs-grid ref="listNe" :dataSource="listdata" height="300">
            <e-columns>
              <e-column type="checkbox" width="10"></e-column>
              <e-column
                field="text"
                :headerText='$t("Software.td_neID")'
                width="80"
                clipMode="EllipsisWithTooltip"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
      <div class="col-sm-9 nopadding:first-child">
        <div class="h-borderBox height-400">
          <PatchVerlibList ref="veblist" :update="false" :hasBorder="true"></PatchVerlibList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PatchVerlibList from "./PatchVerlibList";
import TopoTree from "../topoconfig/TopoTree";
import { stringify } from "qs";
import { isNullOrUndefined } from "@syncfusion/ej2-base";
let Source = [];
export default {
  name: "versionPatchTask",
  props: ["showToast"],
  components: {
    PatchVerlibList,
    TopoTree
  },
  data() {
    return {
      locale: localStorage.getItem("locale"),
      listdata: [],
      input: "",
    };
  },
  methods: {
    _getNeTreeData() {
      this.listdata = [];
      this.$axios
        .post("/lte/ems/auth/findVMEquipmentListByAuth", [10009,10004])
        .then(response => {
          //5G更改只展示GNB设备
          const _nodeArray = response.data;
          const showData = [];
          _nodeArray.forEach(_item => {
            const { id, name, equipmentIP, typeCode ,softwareVersion} = _item;
            let _dataItem = {
              text: name,
              id: id,
              neType: typeCode,
              tooltip: equipmentIP,
              equipmentIPId: _item.EquipmentIP[0].id,
              linkSelect:softwareVersion

            };
            showData.push(_dataItem);
          });
          this.listdata = showData;
          Source = showData;
        });
    },
    getUserId() {
      const principal = JSON.parse(sessionStorage.getItem("principal"));
      return principal ? principal.userId : "110";
    },
    updateVersion(callback) {
      const checkNodes = this.$refs.listNe.getSelectedRecords();
      const NeIdList = Array.from(checkNodes, x => {
        return x.id;
      });
      if (NeIdList.length == 0) {
        this.showToast("warning", `${this.$t("Software.selectDevice")}`);
        return;
      }
      if (NeIdList.length > 10) {
        this.showToast("warning", `${this.$t("Software.updateBSMax")}`);
        return;
      }
      const checkPkg = Array.from(this.$refs.veblist.getSelect(), x => {
        return x.patchId;
      });
      if (checkPkg.length == 0) {
        this.showToast("warning", `${this.$t("Software.selectPkg")}`);
        return;
      }
      if (checkPkg.length > 1) {
        //补丁包安装，目前只支持一次升级一个升级包
        this.showToast("warning", `只选一个升级包`);
        return;
      }
      let config = {
        headers: {
          "Content-Type": "application/json"
        }
      };
      let params = {//4G设备dowload选中是下载升级包到设备侧；5G设备 download 选中走全升级流程
        neIdList: NeIdList,
        pkgList: checkPkg,
      };

       this.$layer.confirm({
          msg: this.$t('MML.neCfgRestoreConfirmTip'),
          btn1: {
            msg: this.$t('Common.cancel')
          },
          btn2: {
            msg: this.$t('Common.ok'),
            func: () => {

          this.$loading.showLoadding(this.$t('Common.waiting'));
          this.axios.post(
                `/lte/ems/verupdate_new/updatePatchVerAction?${stringify(params)}`,
                JSON.stringify(params),
                config
              )
              .then(response => {
                this.$loading.hideLoadding();
                console.log("update", response);
                if (response.status == 200) {
                  if (response.data.errorCode == "SUCCESS") {
                    this.showToast(
                      "success",
                      `${this.$t("Common.tips.success")}`
                    );
                    console.log("update", response);
                    setTimeout(()=>{callback()}, 500)
                  } else {
                    this.showToast("error", response.data.errorString);
                  }
                } else {
                  this.showToast("error", `${this.$t("Common.tips.failure")}`);
                }
              });


            }
          }
        });
    },

    searchMethod() {
      if (this.input === "") {
        this.listdata = Source;
      } else {
        this.listdata = this.search(
          this.input,
          Source,
          this.$refs.listNe.getColumns()
        );
      }
    },
    search(input, source, columns, maparray) {
      var filterdata = source
        .filter(item => {
          let columntext = Array.from(columns, x => {
            return x.field;
          });
          let feildData = Array.from(columntext, x => {
            if (maparray && maparray.has(x)) {
              let value = maparray.get(x).get(item[x]);
              return isNullOrUndefined(value) ? "" : value;
            } else {
              return isNullOrUndefined(item[x]) ? "" : item[x] + "";
            }
          });
          let filres = false;
          feildData.forEach(item => {
            if (item.indexOf(input) > -1) {
              filres = true;
            }
          });
          return filres;
        })
        .map(item => {
          return item;
        });
      return filterdata;
    }
  }
};
</script>>
